module.exports = __webpack_public_path__ + "media/packs/images/flags/FR-6e8ba6f58c86dea720ade8e3aca86b98.svg";